import { EnvironmentProviders, inject, makeEnvironmentProviders, provideEnvironmentInitializer } from "@angular/core";
import { MaterialCssVariablesConfig } from "./material-css-vars.model";
import { MATERIAL_CSS_VARS_CFG } from "./material-css-vars.constants";
import { MaterialCssVarsService } from "@app/app-libs/material-css-vars/material-css-vars.service";

export function provideMaterialCssVars(config?: Partial<MaterialCssVariablesConfig>): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: MATERIAL_CSS_VARS_CFG, useValue: config },
    provideEnvironmentInitializer(() => inject(MaterialCssVarsService))
  ]);
}
